module.exports = __webpack_public_path__ + "img/big_flare.8b55b960.png";